import React, { Component } from "react"
import Checkbox from "./Checkbox"
import produce from "immer"

class CheckboxGroup extends Component {
	constructor(props) {
		super(props)
		this.state = {
			value: new Set()
		}
	}

	_renderCheckbox = v => {
		let checked = false
		if(this.props.value.includes(v.value)) {
			checked = true
		}
		
		return (
			<Checkbox
				label={v.label}
				value={v.value}
				key={v.label}
				checked={checked}
				childChange={this.childChange}
			/>
		)
	}

	childChange = (v) => {
		// this function takes notifications from the chidlren checkboxes and reports back to formik with a json string
		var newState
		if (this.state.value.has(v)) {
			newState = produce(this.state, draft => {
				draft.value.delete(v)
			})

			this.setState(newState, () => {
				this.props.onChange(this.props.name, JSON.stringify(Array.from(this.state.value)))
			})
		}
		else {
			newState = produce(this.state, draft => {
				draft.value.add(v)
			})

			this.setState(newState, () => {
				this.props.onChange(this.props.name, JSON.stringify(Array.from(this.state.value)))
			})
		}
	}

	handleChange = value => {
		var timestamp = value.unix()
		this.props.onChange(this.props.name, timestamp)
	}

	handleBlur = () => {
		this.props.onBlur(this.props.name, true)
	}

	renderCheckboxes = () => this.props.options.map(this._renderCheckbox)

	render() {
		return (
			<div className="form__checkboxGroup">{this.renderCheckboxes()}</div>
		)
	}
}

export default CheckboxGroup
